import update from '../update';

import {
  SET_LOADING,
  SET_PERCENT
} from './constants';

const initialState = {
  isLoading: false,
  percent: 0,
};

const loadingReducer = (state=initialState, action) => {
  switch (action.type) {

    case SET_LOADING:
      return update(state, {
        isLoading: {$set: action.payload},
        percent: {$set: (action.payload === false) ? 0 : state.percent}
      });

    case SET_PERCENT:
      return update(state, {
        percent: {$set: (action.payload > 100) ? 0 : action.payload},
        isLoading: {$set: (action.payload > 100) ? false : true}
      });

    default:
      return state;
  }
}

export default loadingReducer;



// WEBPACK FOOTER //
// ./src/redux/loading/reducer.js